import { fetchData, postData, putData } from "./apis";

const path = "/sales";

export const getDoctorClinicDetailsApi = (val) => {
  let endPoint = `${path}/get-doctor-clinic-details`;
  return postData(endPoint, val);
};

export const getClinicDetailsApi = (val) => {
  let endPoint = `${path}/get-clinic-details`;
  return postData(endPoint, val);
};

export const deleteDoctor = (val) => {
  let endPoint = `${path}/delete-doctor-entry`;
  return postData(endPoint, val);
};

export const deleteClinic = (val) => {
  let endPoint = `${path}/delete-clinic-entry`;
  return postData(endPoint, val);
};

export const getPatientInsuranceDetails = (val) => {
  let endPoint = `${path}/get-patient-insurance-details`;
  return postData(endPoint, val);
};

export const deletePatientEntry = (val) => {
  let endPoint = `${path}/delete-patient-entry`;
  return postData(endPoint, val);
};

export const deleteInsuranceEntry = (val) => {
  let endPoint = `${path}/delete-insurance-entry`;
  return postData(endPoint, val);
};

export const getInsuranceDetails = (val) => {
  let endPoint = `${path}/get-insurance-details`;
  return postData(endPoint, val);
};
